import React, { useEffect, useState } from "react";
import styles from "./newsletter.module.css";
import { Card, Col, Divider, Empty, Row, Space, Spin, Typography } from "antd";
import CustomButton from "../../common/custom-button/custom-button";
import { CalendarOutlined, DeleteOutlined, EditOutlined, PaperClipOutlined, PlusOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import RoutesConstant from "../../constants/routes";
import { deleteNewsletter, getNewsletter } from "../../services/communication";
import { extractFileName } from "../../utils/common";
import dayjs from "dayjs";
import { DATE_FORMAT } from "../../constants/common";
import CustomPopover from "../../common/custom-popover/custom-popover";

const { Title, Text } = Typography;

const NewsLetter = () => {
  const navigate = useNavigate();
  const [newsletters, setNewsletters] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchNewsletter();
  }, []);

  const fetchNewsletter = async () => {
    try {
      setLoading(true);
      const response = await getNewsletter();
      if (response?.status) {
        setNewsletters(response?.data?.data || []);
      }
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    await deleteNewsletter(id);
    await fetchNewsletter();
  };

  return (
    <Spin spinning={loading}>
      <div className={styles.titleContainer}>
        <Typography className={styles.tabTitle}>
          Newsletter
        </Typography>
        <CustomButton
          title="Create Newsletter"
          size="large"
          icon={<PlusOutlined />}
          onClick={() => navigate(RoutesConstant.NEWSLETTER_FORM)}
        />
      </div>
      <Divider />

      {!newsletters?.length && !loading && <Empty />}
      <Row gutter={[16, 16]} className={styles.cardContainer}>
        {newsletters?.map((item, index) => (
          <Col xs={24} sm={24} md={12} lg={8} xl={6} key={index}>
            <Card
              hoverable
              cover={
                <img
                  alt="newsletter"
                  src={item?.cover_image}
                  className={styles.cardImage}
                />
              }
              actions={[
                <div className={styles.cardFooter}>
                  <CustomButton 
                    title="Edit Details"
                    icon={<EditOutlined />}
                    onClick={() => navigate(`${RoutesConstant.NEWSLETTER_FORM}?uid=${item?.id}`)}
                  />
                  <CustomPopover
                    message="Are you sure you want to delete?"
                    confirmText="Delete"
                    cancelText="Cancel"
                    onConfirm={() => handleDelete(item?.id)}
                  >
                    <CustomButton 
                      title="Delete"
                      icon={<DeleteOutlined />}
                      className={styles.deleteButton}
                    />
                  </CustomPopover>
                </div>
              ]}
              className={styles.newsletterCard}
            >
              <Title level={5} className={styles.cardTitle}>
                {item?.title}
              </Title>

              <Space direction="vertical" size={4}>
                <Text type="secondary">
                  <CalendarOutlined />{" Date: "}
                  {dayjs(item?.created_at).format(DATE_FORMAT.DD_SLASH_MM_SLASH_YYYY)}
                </Text>
                <Text type="secondary">
                  <PaperClipOutlined />{" Attachment: "}
                  {item?.news_letter ? (
                    <a
                      href={item?.news_letter}
                      download
                      className={styles.download_link}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {extractFileName(item?.news_letter)}
                    </a>
                  ) : "N/A"}
                </Text>
                <Text type="secondary" style={{ textTransform: "capitalize" }}>
                  {`Audience: ${item?.audience || "N/A"}`}
                </Text>
              </Space>
            </Card>
          </Col>
        ))}
      </Row>
    </Spin>
  );
};

export default NewsLetter;